import { IWebSocketContract } from '@medlogic/medlogic/medlogic-shared-interfaces';
import { EntityState } from '@ngrx/entity';

export interface IWebsocketState extends EntityState<IWebSocketContract> {
    // additional entities state properties
    error: any;
}
